import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import useRazorpay from "react-razorpay";
import { AppContext } from "../../Components/context/app.context";
import {
  Button,
  Grid,
  Typography,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  TextField,
  Checkbox,
  Box,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import BillingAddress from "../Profile/BillingAddress";
import EditBillingAddress from "../Profile/EditBillingAddress";
import AddLocationRoundedIcon from "@mui/icons-material/AddLocationRounded";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { TickIcon } from "../../Components/Styles/Icons";
import { CloseSharp } from "@mui/icons-material";
import { FailurePop, SuccessPop } from "../../Components/Popup";

const AMCPayment = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const planData = location?.state?.data;
  const isRenew = location?.state?.is_renew;
  const getOldId = location?.state?.getOldId;
  const { couponData } = location.state;

  // console.log("couponData", couponData);

  const { carValue, branchValue, fetchCarList, userDetail, getUserData } =
    useContext(AppContext);
  //useStates
  const [content, setContent] = useState("");
  const [modalFail, setModalFail] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);

  const [openAddBillingAddress, setOpenBillingAddress] = useState(false);
  const [openEditBillingAddress, setOpenEditBillingAddress] = useState(false);
  const [selectedBilling, setSelectedBilling] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [finalTotal, setFinalTotal] = useState(0);

  const [Total, setTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [tax, setTax] = useState(0);

  //Discount or Counpon
  const [couponList, setCouponList] = useState([]);
  const [discountValue, setDiscountValue] = useState(0);
  const [selectedCoupon, setSelectedCoupon] = useState("");
  const [discountEnabled, setDiscountEnabled] = useState(false);
  const [couponValue, setCouponValue] = useState("");
  const [couponDisable, setCouponDisable] = useState(false);

  /* Wallet */
  const [walletApplied, setWalletApplied] = useState(false);
  const [appliedAmount, setAppliedAmount] = useState(0);
  const [useWallet, setUseWallet] = useState(false);
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);
  const [currentPoints, setCurrentPoints] = useState(0);
  const [displayAmount, setDisplayAmount] = useState(0);
  const [onePoint, setOnePoint] = useState(0);
  const [pointsDisable, setPointsDiasbled] = useState(false);
  const [usedPoints, setUsedPoints] = useState(0);
  const [availableBalance, setAvailableBalance] = useState(0);

  const params = {
    CarValue: carValue,
    BranchValue: branchValue,
    BillingAddress: selectedBilling,
    subTotal: subTotal,
    DiscountValue: discountValue,
    CouponValue: couponValue,
    AppliedAmount: appliedAmount,
    CurrentPoints: usedPoints,
    UseWallet: walletApplied,
    Tax: tax,
  };

  //Functions

  function findDefaultBilling() {
    userDetail?.billing_address_details?.map((a) => {
      if (a?.is_default) {
        setSelectedBilling(a);
      } else {
        setSelectedBilling(
          userDetail?.billing_address_details
            ? userDetail?.billing_address_details[0]
            : null
        );
      }
    });
  }

  //Wallet Apply
  const handleChange = (event) => {
    setUseWallet(event.target.checked);
    if (event.target.checked) {
      fetchLoyaltyAmount();
    }
  };

  //Wallet Amount manual enter
  function handlePoints(e) {
    if (Number(e.target.value) <= Number(loyaltyPoints)) {
      setAppliedAmount(Math.floor(e.target.value * onePoint));
      setDisplayAmount(Math.floor(e.target.value * onePoint));
      setCurrentPoints(e.target.value);
      setPointsDiasbled(false);
    } else {
      setPointsDiasbled(true);
    }
  }

  //Wallet Apply Submit
  function handleApply() {
    setWalletApplied(true);
    if (appliedAmount >= finalTotal) {
      setAppliedAmount(Math.floor(finalTotal));
      setUsedPoints(Math.floor(finalTotal / onePoint));
      setFinalTotal(0);
    } else if (appliedAmount < finalTotal) {
      setUsedPoints(currentPoints);
      setFinalTotal(Math.floor(Number(finalTotal) - Number(appliedAmount)));
    }
  }

  //To get the wallet Amount of the respective user
  const fetchLoyaltyAmount = async () => {
    try {
      const response = await global.$axios.post("reward/getPointAmount", {
        points: loyaltyPoints,
      });
      // console.log("fetchLoyaltyAmount", response.data);
      if (response.data.status === "success") {
        setAvailableBalance(Math.floor(response?.data?.message?.point_amount));
      } else {
        console.log("fetchLoyaltyAmount Issue", response.data.message);
        setAvailableBalance(0);
      }
    } catch (error) {
      console.log("fetchLoyaltyAmount Issue", error);
    }
  };

  //To get the wallet balance
  const fetchPointsDetail = async () => {
    try {
      const response = await global.$axios.get(
        `reward/pointDetails1/${global.$userData.id}`
      );
      // console.log("response", response.data);
      if (response.data.status === "success") {
        const respo = response.data.message;

        setLoyaltyPoints(respo?.balance_points);
        setCurrentPoints(respo?.balance_points);
        setOnePoint(respo?.onePointAmt);

        setAppliedAmount(
          Math.floor(Number(respo?.balance_points) * Number(respo?.onePointAmt))
        );
        setDisplayAmount(
          Math.floor(Number(respo?.balance_points) * Number(respo?.onePointAmt))
        );
      } else {
        console.log("FetchPointsDetail Issue", response.data.message);
      }
    } catch (error) {
      console.log("FetchPointsDetail Issue", error);
    }
  };

  //Remove Wallet
  const walletValidate = useMemo(async () => {
    if (!useWallet && walletApplied) {
      setWalletApplied(false);
      const add = Number(finalTotal) + Number(appliedAmount);
      setFinalTotal(add);
    } else {
      await fetchPointsDetail();
    }
  }, [useWallet]);

  //Coupon
  //Submitting Coupon on pressing 'enter' key
  const handleCoupon = (event) => {
    if (event.key === "Enter") {
      couponValidate();
    }
  };

  //To Remove the selected Coupon
  const removeCoupon = () => {
    setDiscountEnabled(false);
    setDiscountValue(0);
    setCouponValue("");
    setSelectedCoupon("");
    const add = Number(finalTotal) + Number(discountValue);
    setFinalTotal(add);

    // if (walletApplied) {
    //   if (appliedAmount > Total) {
    //     const add = Number(finalTotal) + Number(discountValue);
    //     setFinalTotal(add);
    //   } else if (appliedAmount < Total) {
    //     // const addOne = Math.abs(Total - Number(appliedAmount));
    //     const add = Number(finalTotal) + Number(discountValue);
    //     setFinalTotal(add);
    //     // setFinalTotal(addOne);
    //   }
    // } else {
    //   const add = Number(finalTotal) + Number(discountValue);
    //   setFinalTotal(add);
    // }
  };

  //To Apply the selected Coupon
  const couponValidate = async () => {
    if (!selectedCoupon) {
      setContent("Enter your coupon code");
      setModalFail(true);
      setTimeout(() => {
        setModalFail(false);
      }, 2000);
    }
    try {
      const amc_id = {
        amc_id: planData?._id,
        price: planData?.price_tire,
      };
      const data = {
        couponCode: selectedCoupon,
        branch_id: branchValue?._id,
        actualPrice: finalTotal,
        type: "AMC",
        amc_id: [amc_id],
        customer_id: global.$userData.id,
      };

      const response = await global.$axios.post(
        "discount/validateCouponType",
        data
      );
      if (response.data.status === "success") {
        const respo = response.data.checkCoupon;
        const respo1 = response?.data?.discountAmount;

        const add = Math.abs(Number(finalTotal) - Number(respo1));
        setDiscountEnabled(true);
        setDiscountValue(Number(respo1));

        setCouponValue(respo._id);
        setFinalTotal(add);

        setContent("Coupon Applied");
        setModalSuccess(true);
        setTimeout(() => {
          setModalSuccess(false);
        }, 1500);
      } else {
        setContent(response.data.message);
        setModalFail(true);
        setTimeout(() => {
          setModalFail(false);
        }, 1500);
      }
    } catch (error) {
      console.log("Coupon Validation Issue", error);
    }
  };

  //Coupon list
  const fetchCouponList = useMemo(async () => {
    try {
      const data = {
        branch_id: branchValue?._id,
        type: "AMC",
        amc_id: planData?._id,
        customer_id: global.$userData.id,
      };
      const response = await global.$axios.post(
        "coupon_master/viewActiveByBranchList",
        data
      );
      if (response.data.status === "success") {
        const respo = response.data.getList;

        if (respo?.length > 0) {
          for (let i = 0; i < respo?.length; i++) {
            if (respo[i]?.is_percentage) {
              let amt = Math.round(
                Total * (Number(respo[i]?.percentage) / 100)
              );
              respo[i].amount = amt;
            }
          }
        }
        setCouponList(respo);
      } else {
        setCouponList([]);
      }
    } catch (error) {
      console.log("Fetch Coupon List Issue ", error);
    }
  }, [branchValue, finalTotal]);

  //Submit
  const [Razorpay, isLoaded] = useRazorpay();

  function handleClick(price, params) {
    if (userDetail?.billing_address_details?.length === 0) {
      setContent("Please Add a Billing Address");
      setOpenBillingAddress(true);
      setModalFail(true);
      return;
    }
    if (!carValue?.reg_number) {
      setContent("Please Choose a Car");
      setModalFail(true);
      return;
    }
    if (price == 0) {
      purchaseAMC("", price, params);
    } else {
      handlePayment(price, params);
    }
  }

  const handlePayment = useCallback(
    async (price, params) => {
      try {
        const {
          CarValue,
          BranchValue,
          BillingAddress,
          subTotal,
          DiscountValue,
          CouponValue,
          AppliedAmount,
          UseWallet,
          CurrentPoints,
          Tax,
        } = params;

        if (!BillingAddress) {
          setContent("Please Select Billing Address");
          setModalFail(true);
          setTimeout(() => {
            setModalFail(false);
          }, 1500);
          return;
        }
        let currentPlanId = isRenew ? { customer_amc_id: getOldId } : {};
        const data = {
          customer_id: global.$userData.id,
          _id: CarValue?._id,
          amc_id: planData?._id,
          amc_soldby: global.$userData.id,
          reg_no: CarValue?.reg_number,
          branch_id: BranchValue?._id,
          services: planData?.services,
          amount: subTotal,
          transaction_id: "",
          //  payment_id: payment,
          source: "Razorpay",
          booking_source: "customer",
          created_by: global.$userData.id,
          billing_details: BillingAddress,
          is_creator: "customer",
          user_id: global.$userData.id,
          plat_form: "web",

          discount: DiscountValue || 0,
          points_amount: UseWallet ? Number(AppliedAmount) : null,
          points_used: CurrentPoints,
          reward_used: UseWallet,
          coupon_id: CouponValue || "",
          tax_percentage: BranchValue?.tax_type?.tax || BranchValue?.tax_type,
          total_tax_price: Tax,
          total: price,
          isRenew: isRenew || null,
          ...currentPlanId,
        };

        // console.log("amc", JSON.stringify(data));
        const finalURL = isRenew
          ? "customer/renewalAmcCustomerRazorPay"
          : "customer/amcbuyCustomer";

        const orderdata = await global.$axios.post(finalURL, data);
        if (orderdata.data.status === "success") {
          const order = orderdata.data.getResponse;
          // console.log("order", order);
          const options = {
            key: order.key, // Enter the Key ID generated from the Dashboard
            amount: order.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "INR",
            name: "5k Car Care",
            description: "Test Transaction",
            image:
              "https://fileserver.treeone.one/view/MTK/20240229141710-5kLogo.svg",
            order_id: order.id, //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
            handler: function (response) {
              fetchOrderStatus(order.id);
            },
            prefill: {
              name: userDetail?.name,
              email: userDetail?.email,
              contact: userDetail?.mobile,
            },
            notes: {
              address: "5K Car Care",
            },
            theme: {
              color: "#3399cc",
            },
          };

          const rzpay = new Razorpay(options);

          rzpay.on("payment.failed", function (response) {
            // alert("code", response.error.code);
            // alert("desc", response.error.description);
            // alert("source", response.error.source);
            // alert("step", response.error.step);
            // alert("reason", response.error.reason);
            // alert("order_id", response.error.metadata.order_id);
            // alert("payment", response.error.metadata.payment_id);
          });

          rzpay.open();
        } else {
          setContent(orderdata.data.message);
          setModalFail(true);
          setTimeout(() => {
            setModalFail(false);
          }, 1500);
        }
      } catch (error) {
        console.log("Fetch Order Id Issue", error);
        return null;
      }
    },
    [Razorpay]
  );

  const fetchOrderStatus = async (id) => {
    try {
      const { data } = await global.$axios.get(`customer/getrazorpayamc/${id}`);
      if (data.status == "success") {
        await fetchCarList();
        Navigate("/app/amcPurchaseSuccess", { state: { data: data.message } });
      } else {
        console.log("AMC Purchase Issue", data);
      }
    } catch (error) {
      console.log("AMC Purchase Issue", error);
    }
  };

  const purchaseAMC = async (payment, price, params) => {
    try {
      const {
        CarValue,
        BranchValue,
        BillingAddress,
        subTotal,
        DiscountValue,
        CouponValue,
        AppliedAmount,
        UseWallet,
        CurrentPoints,
        Tax,
      } = params;
      const data = {
        customer_id: global.$userData.id,
        _id: CarValue?._id,
        amc_id: planData?._id,
        amc_soldby: global.$userData.id,
        reg_no: CarValue?.reg_number,
        branch_id: BranchValue?._id,
        services: planData?.services,
        amount: subTotal,
        transaction_id: "",
        payment_id: "",
        source: "Razorpay",
        booking_source: "customer",
        created_by: global.$userData.id,
        billing_details: BillingAddress,
        is_creator: "customer",
        user_id: global.$userData.id,
        plat_form: "web",

        discount: DiscountValue || 0,
        points_amount: UseWallet ? Number(AppliedAmount) : null,
        points_used: CurrentPoints,
        reward_used: UseWallet,
        coupon_id: CouponValue || "",
        tax_percentage: BranchValue?.tax_type?.tax || BranchValue?.tax_type,
        total_tax_price: Tax,
        total: price,
      };

      console.log("data", data);
      const finalURL = isRenew
        ? "customer/renewalAmcCustomerRazorPay"
        : "customer/updateamc";
      const response = await global.$axios.post(finalURL, data);
      if (response.data.status === "success") {
        await fetchCarList();
        Navigate("/app/amcPurchaseSuccess", {
          state: { data: response.data?.message },
        });
      } else {
        console.log("Something Went Wrong", response.data);
      }
    } catch (error) {
      console.log("Purchase AMC Issue", error);
    }
  };

  //get amc price detail
  const fetchTotal = async () => {
    const sum = Number(planData?.price_tire);

    let noTaxsum = Number(planData?.actual_amcprice);

    let proTax = Number(planData?.gstamount);

    setTax(proTax);
    setSubTotal(noTaxsum);
    setTotal(sum);
    setFinalTotal(sum);
    findOfferAMC(sum, planData);
  };

  const findOfferAMC = async (sum, data) => {
    if (data?.is_offer_applied) {
      setCouponDisable(true);
      setDiscountEnabled(true);

      setDiscountValue(data?.Offer_amount);
      setFinalTotal(Math.abs(Number(sum) - Number(data?.Offer_amount)));
      setCouponValue(couponData?._id);
    }
  };

  useEffect(() => {
    fetchTotal();
    fetchPointsDetail();
  }, []);

  useEffect(() => {
    findDefaultBilling();
  }, [userDetail]);

  return (
    <Grid sx={{ px: { xs: 3, md: 8 }, py: 2 }}>
      {/* <Grid
        sx={{
          mt: { md: 2, xs: 22 },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: { sm: 25, xs: 20 }, fontWeight: 700 }}>
          AMC Purchase
        </Typography>
      </Grid> */}

      <Grid container>
        {/* LHS */}
        <Grid
          item
          xs={12}
          md={5.5}
          sx={{ py: 3, borderRight: { sm: "1px dashed #232323" } }}
        >
          <Typography
            sx={{
              fontSize: { sm: 25, xs: 20 },
              fontWeight: 700,
            }}
          >
            Payment Method
          </Typography>
          {/* Loyalty */}
          <Grid sx={{ my: 3 }}>
            <Grid sx={{ display: "flex", alignItems: "flex-start" }}>
              <Checkbox
                checked={useWallet}
                onChange={handleChange}
                disabled={loyaltyPoints === 0}
                inputProps={{ "aria-label": "controlled" }}
                style={{ width: "20px", padding: 0 }}
                sx={{ mr: 1 }}
              />
              <Typography sx={{ mr: 1 }}>Loyalty Points: </Typography>
              <Typography>{loyaltyPoints}</Typography>
            </Grid>
            {useWallet && (
              <Grid sx={{ mt: 1 }}>
                <TextField
                  value={currentPoints}
                  onChange={handlePoints}
                  disabled={walletApplied}
                  placeholder="Points Price"
                  size="small"
                  helperText={
                    pointsDisable ? (
                      <span style={{ color: "#FF0808" }}>
                        Insufficiant Points
                      </span>
                    ) : (
                      <span>{`Loyalty Price:  ${displayAmount}`}</span>
                    )
                  }
                />
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    mt: 2,
                  }}
                >
                  <Button
                    size="small"
                    variant="contained"
                    sx={{
                      background: "#FF0808",
                      textTransform: "capitalize",
                      ":hover": {
                        background: "#FF0808",
                      },
                    }}
                    onClick={() => {
                      setUseWallet(false);
                      setCurrentPoints(0);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    sx={{
                      background: "#071CB7",
                      textTransform: "capitalize",
                      ":hover": {
                        background: "#071CB7",
                      },
                    }}
                    disabled={
                      pointsDisable || appliedAmount == 0 || walletApplied
                    }
                    onClick={handleApply}
                  >
                    {walletApplied ? "Applied" : "Apply"}
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>

          <RadioGroup defaultValue="Razorpay" value={"Razorpay"}>
            <FormControlLabel
              value="Razorpay"
              control={
                <Radio
                  sx={{
                    color: "#000",
                    "&.Mui-checked": { color: "#071CB7" },
                  }}
                />
              }
              label="Razorpay"
            />
            <Typography sx={{ color: "#C2C2C2" }}>
              Online payment gateway for India
            </Typography>
          </RadioGroup>

          {/* Billing Address */}

          <Grid>
            <Typography sx={{ my: 1, fontWeight: 600 }}>
              Select Your Billing Address{""}
              <span style={{ color: "red" }}> *</span>
            </Typography>
            <div
              style={{
                maxWidth: "99%",
                display: "flex",
                gap: 10,
                overflowX: "auto",
                padding: "10px",
              }}
            >
              {userDetail?.billing_address_details?.map((item, index) => (
                <div
                  key={`${index}${new Date()}`}
                  style={{
                    border:
                      selectedBilling?._id == item?._id
                        ? "1px solid red"
                        : "1px solid #C2C2C2",
                    borderRadius: 10,
                    background:
                      selectedBilling?._id == item?._id ? "#EEEFFB" : "#FFF",
                  }}
                >
                  <div
                    tabIndex="0"
                    style={{
                      width: 190,
                      height: "23vh",
                      overflow: "auto",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    onClick={() => {
                      setSelectedBilling(item);
                    }}
                    role="button"
                  >
                    <Typography sx={{ fontWeight: 600, color: "#071CB7" }}>
                      {item?.label}
                    </Typography>
                    <Typography>{item?.address1}</Typography>
                    <Typography>{item?.address2}</Typography>
                    <Typography>{item?.area}</Typography>
                    <Typography>{item?.city?.name}</Typography>
                    <Typography>{item?.state?.name}</Typography>
                    <Typography>{item?.pincode} </Typography>
                    <Typography>
                      {item?.gst_number
                        ? `GST:${item?.gst_number}`
                        : item?.gst_number}
                    </Typography>
                  </div>

                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      sx={{
                        width: "50%",
                        textTransform: "capitalize",
                        color: "#071CB7",
                      }}
                      size="small"
                      onClick={() => {
                        setSelectedAddress(item);
                        setOpenEditBillingAddress(true);
                      }}
                    >
                      Edit
                    </Button>
                  </Grid>
                </div>
              ))}

              <Grid sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Tooltip title="Add New">
                  <Button
                    size="small"
                    sx={{ textTransform: "capitalize", p: 1 }}
                    onClick={() => setOpenBillingAddress(true)}
                  >
                    <AddLocationRoundedIcon />
                    <Typography>Add Address</Typography>
                  </Button>
                </Tooltip>
              </Grid>
            </div>
          </Grid>
        </Grid>
        {/* RHS */}
        <Grid item xs={12} md={6.5} sx={{ p: 3 }}>
          {/* Selected AMC Detail */}
          <Grid
            container
            sx={{
              background: "#E3E6FF",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              gap: 4,
              p: 2,
              borderRadius: 1,
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CurrencyRupeeIcon fontSize="xs" />
              <Typography sx={{ fontWeight: 700, fontSize: 20 }}>
                {planData?.price_tire} AMC Package
              </Typography>
            </Grid>
            <div style={{ maxHeight: "30vh", overflow: "auto" }}>
              <Grid container sx={{ gap: 1 }}>
                {planData?.services?.map((item, index) => {
                  return (
                    <Grid key={index + 1} sx={{ gap: 3, my: 0.5 }} container>
                      <Grid
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          background: "rgba(0,0,0,0.04)",
                          px: 2,
                          py: 1,
                          borderRadius: 2,
                          width: { xs: "100%", sm: "80%" },
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Box
                            component="img"
                            sx={{
                              height: "80px",
                              width: "80px",
                              borderRadius: 2,
                              objectFit: "contain",
                              boxShadow: "10px 5px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            alt="5k Car Care"
                            src={
                              item?.service_id?.service_image ||
                              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdaOuISNPK0h-pbCWSRXVlLG6YrOr4MdXanw&s"
                            }
                          />
                          <Grid>
                            <div style={{ fontWeight: 600, fontSize: 16 }}>
                              {item?.service_id?.name}
                            </div>
                            <Typography sx={{ fontSize: 12, my: 0.3 }}>
                              {item?.service_id?.description}
                            </Typography>

                            <div
                              style={{ fontWeight: 600, fontSize: 14 }}
                            >{`upto ${item?.service_count} for free.`}</div>
                          </Grid>
                        </Grid>

                        <Grid sx={{ ml: 3 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "rgba(0,0,0,0.06)",
                              height: "30px",
                              width: "30px",
                              borderRadius: "50%",
                            }}
                          >
                            <TickIcon />
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </Grid>
          <Grid
            container
            sx={{
              mt: 3,
            }}
          >
            <Grid item xs={12} sm={6}>
              {/* Discount Coupon */}
              <Grid
                sx={{
                  mt: 1,
                  border: !couponDisable && "0.5px solid rgba(0,0,0,0.1)",
                  borderRadius: 1,
                }}
              >
                {!couponDisable && (
                  <>
                    <Grid sx={{ mb: 1 }}>
                      <Typography
                        sx={{
                          background: "#E8FBFB",
                          color: "#32996A",
                          fontWeight: 550,
                          py: 1,
                          px: 2,
                        }}
                      >
                        Discount Coupons
                      </Typography>

                      <Grid
                        sx={{
                          minHeight: "23vh",
                          maxHeight: "23vh",
                          overflowY: "auto",
                        }}
                        key={couponList}
                      >
                        {couponList?.length > 0 ? (
                          <Grid>
                            {couponList?.map((item, index) => {
                              return (
                                <Grid
                                  key={index + 1}
                                  sx={{
                                    gap: 2,
                                    borderBottom: "1px dashed #000",
                                    p: 2,
                                    mx: 1.5,
                                  }}
                                >
                                  <RadioGroup
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                    row
                                    value={selectedCoupon}
                                    onChange={(e) => {
                                      setSelectedCoupon(e.target.value);
                                    }}
                                  >
                                    <FormControlLabel
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        textAlign: "right",
                                        p: 0,
                                        m: 0,
                                      }}
                                      value={item?.name}
                                      disabled={discountEnabled}
                                      control={
                                        <Radio
                                          sx={{
                                            color: "#000",
                                            "&.Mui-checked": {
                                              color: "#071CB7",
                                            },
                                            textAlign: "right",
                                          }}
                                        />
                                      }
                                      label={item?.name}
                                    />
                                  </RadioGroup>
                                  <Grid
                                    sx={{
                                      gap: 1,
                                      alignItems: "center",
                                    }}
                                    container
                                  >
                                    {item?.is_combo && (
                                      <Typography
                                        sx={{
                                          fontSize: 10,
                                          color: "red",
                                          px: 3,
                                        }}
                                      >
                                        Special Offer
                                      </Typography>
                                    )}
                                    {item?.coupon_type === "Customized" && (
                                      <Typography
                                        sx={{
                                          fontSize: 10,
                                          color: "red",
                                          px: 3,
                                        }}
                                      >
                                        Only for you
                                      </Typography>
                                    )}
                                  </Grid>
                                  <Typography>{item?.description}</Typography>
                                </Grid>
                              );
                            })}
                          </Grid>
                        ) : (
                          <Grid
                            sx={{
                              alignItems: "center",
                              justifyContent: "center",
                              mt: 5,
                            }}
                            container
                          >
                            No Coupon Found!!!
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ background: "#E7E8F8", p: 2 }}>
                      {discountEnabled ? (
                        <Grid item sx={{}}>
                          <Typography>Applied Coupon</Typography>
                          <Grid
                            item
                            sx={{
                              alignItems: "center",
                              display: "flex",
                              background: "#FFF",
                              pr: 1,
                              pl: 2,
                              borderRadius: 10,
                              mt: 1,
                              gap: 1,
                            }}
                          >
                            <Typography>{selectedCoupon}</Typography>
                            <IconButton sx={{}} onClick={removeCoupon}>
                              <CloseSharp />
                            </IconButton>
                          </Grid>
                        </Grid>
                      ) : (
                        <React.Fragment>
                          <Typography>
                            Have a different discount/promo code to redeem ?
                          </Typography>
                          <Grid
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-around",
                              mt: 1,
                              flexDirection: { xs: "column", md: "row" },
                              gap: { xs: 1, md: 0 },
                            }}
                            container
                            item
                          >
                            <TextField
                              value={selectedCoupon}
                              onChange={(e) =>
                                setSelectedCoupon(e.target.value)
                              }
                              placeholder="Enter the Coupon Code"
                              size="small"
                              onKeyDown={handleCoupon}
                              sx={{ width: { md: "75%", xs: "100%" } }}
                              inputProps={{ type: "search" }}
                            />
                            <Button
                              size="small"
                              variant="contained"
                              disabled={!selectedCoupon || discountEnabled}
                              onClick={couponValidate}
                              sx={{
                                width: { xs: "30%", md: "18%" },
                                py: 1,
                                textTransform: "none",
                                background: "#071CB7",
                              }}
                            >
                              Apply
                            </Button>
                          </Grid>
                        </React.Fragment>
                      )}
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} sx={{ mb: 1, py: 2 }}>
              <Grid>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      width: "60%",
                      textAlign: "right",
                    }}
                  >
                    Sub Total:
                  </Typography>

                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <CurrencyRupeeIcon fontSize="xs" />
                    <Typography sx={{ fontWeight: 600 }}>
                      {Number(subTotal)?.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                    borderBottomColor: "#232323",
                    borderBottomWidth: 1,
                    borderBottomStyle: "solid",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      width: "60%",
                      textAlign: "right",
                    }}
                  >
                    Tax:
                  </Typography>

                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <CurrencyRupeeIcon fontSize="xs" />
                    <Typography sx={{ fontWeight: 600 }}>
                      {Number(tax)?.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      width: "60%",
                      textAlign: "right",
                    }}
                  >
                    Total:
                  </Typography>

                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <CurrencyRupeeIcon fontSize="xs" />
                    <Typography sx={{ fontWeight: 600 }}>
                      {Number(Total)?.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>

                {discountEnabled && (
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        width: "60%",
                        textAlign: "right",
                      }}
                    >
                      Discount:
                    </Typography>

                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      {"- "} <CurrencyRupeeIcon fontSize="xs" />
                      <Typography sx={{ fontWeight: 600 }}>
                        {Number(discountValue)?.toFixed(2)}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                {walletApplied && (
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        width: "60%",
                        textAlign: "right",
                      }}
                    >
                      Loyalty Price:
                    </Typography>

                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      {"- "} <CurrencyRupeeIcon fontSize="xs" />
                      <Typography sx={{ fontWeight: 600 }}>
                        {Number(appliedAmount)?.toFixed(2)}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      width: "60%",
                      textAlign: "right",
                    }}
                  >
                    To Pay:
                  </Typography>

                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <CurrencyRupeeIcon fontSize="xs" />
                    <Typography sx={{ fontWeight: 600 }}>
                      {Number(finalTotal)?.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: 2,
                }}
              >
                <Grid
                  sx={{ alignItems: "center", justifyContent: "center", mt: 5 }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      background: "#071CB7",
                      textTransform: "capitalize",
                      px: 5,
                      ":hover": { background: "#071CB7" },
                    }}
                    onClick={() => handleClick(finalTotal, params)}
                  >
                    {finalTotal == 0 ? "Book Now" : "Pay Now"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {openAddBillingAddress && (
        <BillingAddress
          openAddBillingAddress={openAddBillingAddress}
          setOpenBillingAddress={setOpenBillingAddress}
          getUserData={getUserData}
        />
      )}

      {openEditBillingAddress && (
        <EditBillingAddress
          openEditBillingAddress={openEditBillingAddress}
          setOpenEditBillingAddress={setOpenEditBillingAddress}
          getUserData={getUserData}
          selectedAddress={selectedAddress}
        />
      )}

      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}
      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
    </Grid>
  );
};

export default AMCPayment;
